import { Container, Divider, Grid, Segment } from "semantic-ui-react";
import IkonHjerte from "../images/IkonHjerte.svg";
import IkonParaply from "../images/Rain-Umbrella.png";
import IkonSparegris from "../images/IkonSparegris.svg";
import IkonGrafer from "../images/IkonGrafer.svg";
import IkonKiste from "../images/IkonKiste.svg";
import "./Selvstaendige.css";
import HeaderImage from "./common/HeaderImage";
import Forsidebillede from "../images/pensionsdagen2025.jpg";

const Pensionsdagen = (props) => (
  <div style={{ backgroundColor: "white" }}>
    <HeaderImage imageSrc={Forsidebillede} />
    <Container text>
      <Segment basic>
        <p>Oktober 2025</p>
        <h2 className="trompet">
          FÅ OVERBLIK OVER DIN PENSION - DIN RÅDGIVER KAN HJÆLPE DIG
        </h2>
        <h2 className="ui header" style={{ paddingTop: 0 }}>
          Du får en ekstra time, men det tager kun 10 minutter
        </h2>
      </Segment>
    </Container>

    <Container text>
      <Segment basic>
        <p className="manchet">
          Når hverdagen ruller, kan det være svært at finde tid til at tjekke
          sin pension – selvom man egentlig gerne vil.
        </p>

        <p>
          Den sidste søndag i oktober får vi alle en ekstra time foræret, når
          sommertiden slutter. Hvorfor ikke bruge lidt af den på at skabe
          klarhed over din pension?
        </p>

        <h3>Det er nemt, og der er hjælp at hente</h3>
        <p>
          Log ind på{" "}
          <a href="https://pensionsinfo.dk" target="_blank" rel="noreferrer">
            pensionsinfo.dk
          </a>{" "}
          med MitID. Med få klik kan du hente en rapport over din samlede
          pension og sende den direkte til din rådgiver i dit pengeinstitut. Det
          tager ikke engang 10 minutter.
        </p>
        <p>
          Derefter kan du sammen med din rådgiver se på, om din opsparing
          matcher dine ønsker for livet som pensionist – og om dine forsikringer
          passer til din situation.
        </p>

        <p>
          TIP! Log på PensionsInfo via dit pengeinstitut, så bliver rapporten
          sendt direkte til din rådgiver.
        </p>

        <Divider hidden />

        <Segment basic style={{ backgroundColor: "#f6f0e7", color: "black" }}>
          <h3 style={{ color: "#e49d3b" }}>
            Har du en årsindkomst mellem 640.000 og 750.000 kr.? Så bør du
            handle nu
          </h3>

          <p>
            Fra 2026 ændres skattereglerne, og fradragsværdien af topskat falder
            markant – fra 15 % til 7,5 %. Det betyder, at du i 2025 har en
            særlig mulighed: Ved at øge dine pensionsindbetalinger i år, kan du
            udnytte den højere fradragsværdi, inden reglerne træder i kraft.
          </p>

          <p>
            Tal med din rådgiver i dit pengeinstitut, så I sammen kan se på,
            hvordan du bedst kan udnytte fordelen.
          </p>
        </Segment>

        <Divider hidden />

        <h3>Gode råd til at få overblik</h3>
        <p>
          Her finder du inspiration til, hvilke spørgsmål du kan stille dig
          selv, når du vil skabe et overblik, der favner hele vejen rundt. Og
          husk – din rådgiver i pengeinstituttet kan hjælpe dig.
        </p>

        <Divider hidden />

        <Grid centered stackable columns={2}>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${IkonSparegris})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <h4>Indbetaler du nok?</h4>
              <p>
                Vil du gerne kunne skrue ned for arbejdstiden, før du går på
                pension? Eller måske trække dig helt tilbage lidt tidligere?
                Eller handler det for dig om at fastholde levestandarden, når
                pensionsalderen nærmer sig? Uanset hvad du drømmer om, giver det
                ro at vide, om økonomien rækker. Jo før du får styr på det, jo
                flere handlemuligheder har du.
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${IkonParaply})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <h4>Hvordan ser dit sikkerhedsnet ud?</h4>
              <p>
                Har du overblik over dine forsikringer – og ved du, hvornår og
                hvordan de dækker? Pension handler ikke kun om opsparing, men
                også om de forsikringer, der støtter dig, hvis du bliver syg
                eller kommer til skade. Et solidt økonomisk sikkerhedsnet giver
                tryghed i hverdagen.
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${IkonHjerte})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <h4>Sundhedsforsikring – en ekstra tryghed?</h4>
              <p>
                En sundhedsforsikring kan give dig hurtig adgang til behandling
                eller udredning, hvis du får helbredsproblemer. Det kan være alt
                fra fysioterapeut og kiropraktor til psykolog eller psykiater.
                Har du børn, kan en sundhedsforsikring også hjælpe, hvis de
                mistrives.
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${IkonGrafer})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <h4>Har du den rette investeringsprofil?</h4>
              <p>
                Den bedste investeringsprofil er den, der giver dig ro i maven.
                Markederne svinger, og investering indebærer altid risiko.
                Spørgsmålet er, hvor meget risiko du er villig til at løbe for
                at opnå et afkast. Husk, at pension er en langsigtet opsparing –
                derfor er det vigtigt at holde fast i din strategi fremfor at
                forsøge at time markedet.
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${IkonKiste})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <h4>Hvem skal have opsparingen, hvis du dør for tidligt?</h4>
              <p>
                Det er værd at overveje, hvem der skal have udbetalingerne fra
                din pension, hvis du ikke selv når at bruge den. Hvert år dør
                ca. 9.000 danskere, inden de går på pension, og ca. 9 mia. kr.
                bliver udbetalt til de efterladte. På{" "}
                <a
                  href="https://pensionsinfo.dk"
                  target="_blank"
                  rel="noreferrer"
                >
                  pensionsinfo.dk
                </a>{" "}
                kan du se, hvem der står som begunstiget på dine ordninger.
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Divider hidden />

        <h3>Hvornår er det tid til at tjekke din pension?</h3>
        <p>Vi får ofte spørgsmål: Hvor ofte bør jeg tjekke min pension?</p>
        <p>
          Vi anbefaler, at du minimum en gang om året tjekker din pension.
          Derudover er store livsændringer også anledning:
        </p>

        <ul>
          <li>Nyt job – gennemgå ordningen, når du skifter arbejdsplads.</li>
          <li>Store livsbegivenheder – fx ægteskab, skilsmisse eller børn.</li>
          <li>
            Ændringer i indkomst – justér indbetalingerne, hvis din løn stiger
            eller falder.
          </li>
          <li>
            Boligkøb eller -salg – tænk pensionen ind i de nye økonomiske
            rammer.
          </li>
          <li>
            Når du nærmer dig pensionsalderen – planlæg udbetalingerne i god
            tid, så rækkefølgen optimerer din økonomi.
          </li>
        </ul>
      </Segment>
    </Container>
  </div>
);

export default Pensionsdagen;
